import Udesk from 'Udesk';
import Component from './template-new';
export default Udesk.react.udeskify(Component);
